import Crud from './crud'
var crud = new Crud('staff_configs', 'người tạo');

const state = {
    ...crud.state,
    selected: {
        id: 0,
        name: ''
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
